export const INITIAL_STATE = {
  mode: 'apps'
}

const reducer = (state = INITIAL_STATE, action) => {

  switch (action.type) {

  case 'SET_MODE':
    return {
      ...state,
      mode: action.mode
    }

  default:
    return state

  }

}

export default reducer
